import { render, staticRenderFns } from "./BaseSingleCollapse.vue?vue&type=template&id=1305cd58"
import script from "./BaseSingleCollapse.vue?vue&type=script&lang=js"
export * from "./BaseSingleCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports